/**
 * @constant {initialState}
 *
 * @see Redux store thread and confluence
 *
 * A multi-dimensional object:
 * {
 *     event_id: {
 *         market_id: {
 *             selection_id: {
 *                 ...selection data
 *             }
 *         }
 *     }
 * }
 */
export const initialState = {};
